module.exports = __webpack_public_path__ + "img/rgbits_jumbiedao.gm.b76956a.png";